import { gaTracking, getCurrentPageLocation } from "../../lib/ga";

/**
 * Tracks section visibility/impression events
 * @param title - Title of the section
 * @param index - Position of the section on the page
 * @see /GAExamples/section_impression.js
 */
export const sectionImpressionTracker = (title: string, index?: number): void => {
  gaTracking({
    event: "section_impression",
    event_parameters: {
      page_location: getCurrentPageLocation(),
      title,
      index,
    },
  });
};
